// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"ca6b21e4","399":"ca6b21e4","575":"e4a96a50","836":"9c3386a4","940":"ca6b21e4"}[chunkId] + ".chunk.css";
};